import { jsx, jsxs } from "react/jsx-runtime";
import cx from "classnames";
import SSRIcon from "@ingka/ssr-icon";
import bulletIcon from "@ingka/ssr-icon/paths/bullet";
const OfferMessage = (props) => {
  const { prefix = "", children, type = "subtle", bullet = true } = props;
  if (!children) return null;
  const baseClass = `${prefix}price-module__offer-message`;
  const classes = cx(
    baseClass,
    type === "family" && `${baseClass}--family`,
    type === "emphasised" && `${baseClass}--emphasised`
  );
  return /* @__PURE__ */ jsxs("div", { className: classes, children: [
    bullet && /* @__PURE__ */ jsx(SSRIcon, { paths: bulletIcon, prefix }),
    /* @__PURE__ */ jsx("span", { children })
  ] });
};
var OfferMessage_default = OfferMessage;
export {
  OfferMessage_default as default
};
